import React, { createContext, useContext } from 'react'

const MainDataContext = createContext(null)

const MainDataProvider = ({ data, children }) => {
  return (
    <MainDataContext.Provider value={data}>
      {children}
    </MainDataContext.Provider>
  )
}

const useMainData = () => {
  const context = useContext(MainDataContext)
  if (context === undefined) {
    throw new Error('useMainData must be used within a MainDataProvider')
  }
  return context
}

export { MainDataProvider, useMainData }
